import React, { useState } from 'react'

import Pagination from '../components/pagination'
import { Loading } from '../../shared/components'
import '../../../stylesheets/utility/flash-error.css'
import { useGetOrderHistoryIndex } from '../hooks/get-order-history-index.jsx'
import storage from '../../services/storage'

import OrderDetailsCard from '../components/order-details-card.jsx'
import dateFormat from '../../shared/helpers/date-format'

const OrderIndexView = () => {
  document.body.scrollTop = document.documentElement.scrollTop = 0
  const [currentIndexPage, setCurrentIndexPage] = useState(1)
  const { isLoading, isError, data, error } = useGetOrderHistoryIndex()
  const pageSize = 20

  const day = new Date()
  day.setFullYear(day.getFullYear() - 1)
  let { full } = dateFormat
  const TEST_CURRENT_DATE = storage.getItem('testCurrentDate')
  let TEST_JS_DATE = null
  if (TEST_CURRENT_DATE) {
    const [year, month, day] = TEST_CURRENT_DATE.split('-')
    TEST_JS_DATE = new Date(year - 1, month - 1, day)
  }

  const yearMessage = `For information about orders purchased before ${full(
    TEST_JS_DATE || day
  )}, please call 312-939-2438`

  const onNext = () => {
    setCurrentIndexPage(currentIndexPage + 1)
  }

  const onPrevious = () => {
    if (currentIndexPage > 1) {
      setCurrentIndexPage(currentIndexPage - 1)
    }
  }

  const paginate = content => {
    const firstPageIndex = (currentIndexPage - 1) * pageSize
    const lastPageIndex = firstPageIndex + pageSize
    return content.slice(firstPageIndex, lastPageIndex)
  }

  return (
    <div>
      {isLoading && <Loading />}

      {isError && !isLoading && (
        <div
          tabIndex="-1"
          className="md:h-0 md:w-full md:absolute md:inset-x-0"
        >
          <div className="flash-error m-auto p-12 table bg-red text-white text-16 z-10">
            {error.message}
          </div>
        </div>
      )}

      {data && !isError && data.orders.length === 0 && (
        <p className="text-22">It doesn't look like you have any orders yet.</p>
      )}

      {data && data.orders.length > 0 && (
        <div>
          <div>
            <h3>Your Recent Orders</h3>

            <p>
              Review your order history below. Orders are listed from newest to
              oldest by order date.
            </p>

            {paginate(data.orders).map(order => (
              <OrderDetailsCard
                key={order.odOrderNumber}
                order={order}
              />
            ))}

            <Pagination
              totalCount={data.orders.length}
              currentPage={currentIndexPage}
              pageSize={pageSize}
              onNext={onNext}
              onPrevious={onPrevious}
            />
          </div>
          <p className="pb-20">{yearMessage}</p>
        </div>
      )}
    </div>
  )
}

export default OrderIndexView
